<div class="modal-header">
    <h4 class="modal-title pull-left primary-color">{{title}}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="onCancelClick()">
            <span aria-hidden="true">&times;</span>
        </button>
</div>
<div class="modal-body  grey-color">
    <p>{{message}}</p>
    <div class='d-flex justify-content-between mt-5'>
        <button (click)='onCancelClick()' class='btn btn--primary-outline'>{{cancelText}}</button>
        <button (click)='onConfirmClick()' class='btn btn--primary'>Potvrdit</button>
    </div>
</div>
